import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "video", "playOverlay", "muteIcon", "unmuteIcon"];

  connect() {
    this.isMuted = true;

    // Initialize Intersection Observer
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.6, // Video must be 60% visible to play
    });

    if (this.hasVideoTarget) {
      this.observer.observe(this.videoTarget);
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!this.hasVideoTarget) return;

      if (entry.isIntersecting) {
        this.videoTarget.play().catch((error) => {
          // Browser might block auto-play if not muted
          console.log("Autoplay prevented:", error);
        });
        this.playOverlayTarget.classList.add("hidden");
      } else {
        this.videoTarget.pause();
        this.playOverlayTarget.classList.remove("hidden");
      }
    });
  }

  // --- UI Actions ---
  toggleMute(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isMuted = !this.isMuted;
    this.videoTarget.muted = this.isMuted;
    this.muteIconTarget.classList.toggle("hidden");
    this.unmuteIconTarget.classList.toggle("hidden");
  }

  toggleMenu(e) {
    e.preventDefault();
    this.menuTarget.classList.toggle("hidden");
  }

  hideMenu(e) {
    if (!this.element.contains(e.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
